import { render, staticRenderFns } from "./WorkTaskCreateDialog.vue?vue&type=template&id=4ab4e853"
import script from "./WorkTaskCreateDialog.vue?vue&type=script&lang=ts"
export * from "./WorkTaskCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports